module.exports = {
          srcSet: __webpack_public_path__ + "public/images/a9f2d5e71b2d2549786e86ccbf6b04b3-1774.jpg"+" 1774w",
          images:[ {path: __webpack_public_path__ + "public/images/a9f2d5e71b2d2549786e86ccbf6b04b3-1774.jpg",width: 1774,height: 887}],
          src: __webpack_public_path__ + "public/images/a9f2d5e71b2d2549786e86ccbf6b04b3-1774.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/a9f2d5e71b2d2549786e86ccbf6b04b3-1774.jpg"},
          
          width: 1774,
          height: 887
        }